module.exports = __webpack_public_path__ + "img/2024.be36a72a.png";